module.exports = __webpack_public_path__ + "fonts/terminal.svg?3cef85af";